import React from 'react';

export default function NoData() {
  return (
    <div className="mt20">Please, wait ...</div>
  );
}
